module.exports = __webpack_public_path__ + "static/Collabs-7a58da8e178eb360bee94fdc472a72ea.png";